import NavigatableHeader, {
  PodcastTableGoBackButton,
} from 'components/NavigatableHeader';
import ClaimPodcastButton from 'pages/Play/ClaimPodcastButton';
import { useClaimedPodcastTitle, usePodcast } from 'pages/Play/state';

interface TableTitleProps {
  onBackClick: () => void;
}

const TablePageTitle: React.FC<TableTitleProps> = ({ onBackClick }) => {
  const { podcastId } = usePodcast();

  const { data: podcastTitle } = useClaimedPodcastTitle(podcastId);

  const subtitle = (() => {
    if (podcastId) {
      return <PodcastTableGoBackButton onClick={onBackClick} />;
    }
    return 'Select a podcast to see how it’s performing on our listening app.';
  })();

  return (
    <NavigatableHeader
      title={podcastTitle ?? 'Your Podcasts'}
      subtitle={subtitle}
      button={
        !podcastId && <ClaimPodcastButton>add a podcast</ClaimPodcastButton>
      }
    />
  );
};
export default TablePageTitle;
